<div class="modal fade" tabindex="-1"
     id="IosDownloadModal"
     aria-label="So laden Sie eine Anlage hoch" #modalDialogEl>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <button type="button" class="ba-modal-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
      </div>

      <div class="modal-body">
        <div class="text-align-center">
          <div class='ba-icon ba-icon-download'></div>
          <h1 id="FMS_Dialog_WBA_keine_Berechtigung_Title">Datei herunterladen</h1>
        </div>

        <div class="row">
          <div class="col-xs-12 ba-centered-buttons">
            <button #anchorElement
                    target="_self"
                    class="ba-btn ba-btn-primary"
                    id="btn_ios_download">
              Herunterladen
            </button>
          </div>
        </div>

      </div>

    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
